module.exports = __webpack_public_path__ + "media/tabata_start_exe.fdd82b33.wav";